import React from 'react';

const Badge = ({
  content,
  backgroundColor = 'rgba(225, 33, 71, 0.15)',
  color = 'rgba(225, 33, 71, 0.8)',
  style: overwriteStyles = {},
}) => {

  const styles = {
    container: {
      backgroundColor,
      color,
      fontSize: 11,
      fontWeight: 500,
      padding: '4px 10px',
    },
  };

  return <div style={{ ...styles.container, ...overwriteStyles }}>{content}</div>;
};

export default Badge;
